import axios from "axios";

const logout = async (): Promise<void> => {
  try {
    const apiUrl = import.meta.env.VITE_API_URL;
    await axios.get(`${apiUrl}/logout`, { withCredentials: true });
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userId");
    localStorage.removeItem("email");
  } catch (error: any) {
    // console.error("Logout failed:", error?.response?.data || error.message);
    throw error;
  }
};

export default logout;
